import StateHistory from '../utils/StateHistory';

export default function StateRecorder(state, action) {
	StateHistory.addAction(action);
	return state;

}

